function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.is-array.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React from 'react';
import { compose, withHandlers, withState, withStateHandlers, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dropzoneEnhancer from "../../../../components/dropzoneEnhancer";
import handleApiErrorResponse from "../../../../util/handleApiErrorResponse";
import { uploadSingleFilePost } from "../../../../api/fileUpload";
import { raiseErrorMessage, raiseSuccessMessage, useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../../hooks/useInitialProps";
import { getFileExtensionFromFilename } from "../../../../util/common";
import { loadBaseApplication as _loadBaseApplication } from "../../enhancer";
var VerificationResult = {
  CHECK_FAILURE: 'check_failure',
  LOW_QUALITY: 'low_quality',
  NAME_NOT_MATCH: 'name_not_match',
  NOT_CHECKED: 'not_checked',
  SUCCESSFULLY_PASSED: 'successfully_passed',
  IELTS_SCORE_MISMMATCH: 'ielts_score_mismatch',
  STUDENT_INELIGIBLE: 'student_ineligible',
  DOCUMENT_MISMATCH: 'document_mismatch'
};

/**
 * @returns {Promise<{ data: { data: { id: number, attributes: { automated_verification_results: Array<{ result_code: string }> } } } }>}
 */
var uploadFileToRequirement = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, file, onProgress) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return uploadSingleFilePost(url, 'file', file, onProgress);
        case 3:
          response = _context.sent;
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          handleApiErrorResponse(_context.t0);
        case 9:
          return _context.abrupt("return", response);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function uploadFileToRequirement(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var fileUploadsEnhancer = compose(
// TODO: remove this after refactoring recompose.  Not doing now since this is
// a complicated enhancer and because of time pressure
// eslint-disable-next-line react/display-name
function (Component) {
  return function (props) {
    var _useEventTracker = useEventTracker(),
      trackEvent = _useEventTracker.trackEvent;
    var initialProps = useInitialProps();
    return /*#__PURE__*/React.createElement(Component, _extends({
      trackEvent: trackEvent,
      userRole: initialProps.role,
      applicationId: initialProps.id
    }, props));
  };
}, connect(null, function (dispatch, _ref2) {
  var requirement = _ref2.requirement;
  return {
    addFileToStoreAction: function addFileToStoreAction(file_data) {
      return dispatch({
        type: requirement.requirement_template_type === 'document' ? 'ADD_ATTACHMENT_TO_REQUIREMENT' : 'ADD_RECEIPT_ATTACHMENT_TO_REQUIREMENT',
        data: file_data,
        requirement_id: requirement.id
      });
    },
    loadBaseApplication: function loadBaseApplication(applicationId) {
      return _loadBaseApplication(applicationId, dispatch);
    }
  };
}), withState('verificationModalAttachmentIds', 'setVerificationModalAttachmentIds', []), withStateHandlers({
  progressProps: {
    visible: false
  }
}, {
  showProgress: function showProgress(_ref3) {
    var progressProps = _ref3.progressProps;
    return function () {
      var progress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return {
        progressProps: _objectSpread(_objectSpread({}, progressProps), {}, {
          visible: true,
          progress: progress
        })
      };
    };
  },
  setProgressLabel: function setProgressLabel(_ref4) {
    var progressProps = _ref4.progressProps;
    return function () {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        progressProps: _objectSpread(_objectSpread({}, progressProps), {}, {
          label: label
        })
      };
    };
  },
  hideProgress: function hideProgress(_ref5) {
    var progressProps = _ref5.progressProps;
    return function () {
      return {
        progressProps: _objectSpread(_objectSpread({}, progressProps), {}, {
          visible: false
        })
      };
    };
  }
}), withHandlers({
  onDrop: function onDrop(_ref6) {
    var requirement = _ref6.requirement,
      onUploadFinished = _ref6.onUploadFinished,
      showProgress = _ref6.showProgress,
      setProgressLabel = _ref6.setProgressLabel,
      hideProgress = _ref6.hideProgress,
      addFileToStoreAction = _ref6.addFileToStoreAction,
      setVerificationModalAttachmentIds = _ref6.setVerificationModalAttachmentIds,
      trackEvent = _ref6.trackEvent,
      userRole = _ref6.userRole,
      dispatch = _ref6.dispatch,
      applicationId = _ref6.applicationId,
      loadBaseApplication = _ref6.loadBaseApplication,
      reloadAggregatedData = _ref6.reloadAggregatedData;
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(files) {
        var _requirement$attachme;
        var fileLimit, nonRejectedRequirementAttachments, returnValue, url, allowedFileTypes, maxFilesForRequirement, maxFilesUploadableAtOnce, _window$toastr, allowedFiles, _iterator, _step, file, fileExtension, numUploadedFiles, uploadedBytesPerFile, estimatedTotal, verificationModalAttachmentIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              fileLimit = requirement.file_upload_limit ? requirement.file_upload_limit : requirement.max_file_upload_limit;
              nonRejectedRequirementAttachments = ((_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : _requirement$attachme.filter(function (attachment) {
                return (attachment === null || attachment === void 0 ? void 0 : attachment.status) !== 'disapproved';
              })) || [];
              if (!((files === null || files === void 0 ? void 0 : files.length) + nonRejectedRequirementAttachments.length > fileLimit)) {
                _context3.next = 5;
                break;
              }
              raiseErrorMessage("Only ".concat(fileLimit, " file(s) can be uploaded to this requirement."));
              return _context3.abrupt("return");
            case 5:
              returnValue = [];
              url = "/api/awa/pages/applications/".concat(applicationId, "/data/requirements/").concat(requirement.id, "/attachments?include=requirement_status,requirement_updated_at");
              allowedFileTypes = requirement.file_types.map(function (ft) {
                // this makes sure validation works for mime types or simple file extension strings
                var pieces = ft.split('/');
                switch (pieces[pieces.length - 1]) {
                  case 'plain':
                    return 'txt';
                  case 'msword':
                    return 'doc';
                  case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return 'docx';
                  case 'vnd.ms-excel':
                    return 'xls';
                  case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return 'xlsx';
                  default:
                    return pieces[pieces.length - 1];
                }
              });
              if (allowedFileTypes.indexOf('jpeg') >= 0) {
                allowedFileTypes.push('jpg');
              }
              maxFilesForRequirement = requirement.file_upload_limit;
              maxFilesUploadableAtOnce = typeof maxFilesForRequirement === 'number' && maxFilesForRequirement > 0 ? Math.min(maxFilesForRequirement, 20) : 20;
              if (!(files.length > maxFilesUploadableAtOnce)) {
                _context3.next = 14;
                break;
              }
              if ((_window$toastr = window.toastr) !== null && _window$toastr !== void 0 && _window$toastr.error) {
                window.toastr.error("Documents not attached: Please attach ".concat(maxFilesUploadableAtOnce, " or less documents at once."));
              }
              return _context3.abrupt("return", []);
            case 14:
              allowedFiles = [];
              _iterator = _createForOfIteratorHelper(files);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  file = _step.value;
                  fileExtension = getFileExtensionFromFile(file);
                  if (allowedFileTypes.indexOf(fileExtension) < 0) {
                    raiseErrorMessage("We only accept the following file types for this requirement: ".concat(allowedFileTypes.sort().join(', ')));
                  } else {
                    allowedFiles.push(file);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              numUploadedFiles = 0;
              uploadedBytesPerFile = {};
              estimatedTotal = allowedFiles.reduce(function (acc, curr) {
                return acc + curr.size;
              }, 0);
              showProgress(0);
              setProgressLabel("0/".concat(allowedFiles.length, " files uploaded"));
              _context3.next = 24;
              return Promise.allSettled(allowedFiles.map( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, fileIdx) {
                  var fileExtension, response;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        fileExtension = getFileExtensionFromFile(file);
                        _context2.prev = 1;
                        _context2.next = 4;
                        return uploadFileToRequirement(url, file, function (event) {
                          uploadedBytesPerFile[fileIdx] = event.loaded;
                          if (event.loaded >= event.total) {
                            numUploadedFiles++;
                          }
                          var totalLoaded = Object.values(uploadedBytesPerFile).reduce(function (acc, curr) {
                            return acc + curr;
                          }, 0);
                          showProgress(Math.min(totalLoaded / estimatedTotal, 1));
                          setProgressLabel("".concat(numUploadedFiles, "/").concat(allowedFiles.length, " files uploaded"));
                        });
                      case 4:
                        response = _context2.sent;
                        if (response) {
                          returnValue.push(response);
                          raiseSuccessMessage("Successfully uploaded ".concat(response.data.data.attributes.file_name));
                          addFileToStoreAction(response.data.data);
                          trackEvent({
                            event: 'Single Application - Applicant Requirements - Successful File Upload',
                            data: {
                              userRole: userRole,
                              requirementId: requirement.id,
                              requirementType: requirement.requirement_template_type,
                              categoryId: requirement.requirement_category,
                              fileType: fileExtension,
                              fileSize: file.size
                            }
                          });
                          reloadAggregatedData();
                          loadBaseApplication(applicationId);
                        }
                        _context2.next = 11;
                        break;
                      case 8:
                        _context2.prev = 8;
                        _context2.t0 = _context2["catch"](1);
                        trackEvent({
                          event: 'Single Application - Applicant Requirements - Unsuccessful File Upload',
                          error: _context2.t0,
                          data: {
                            userRole: userRole,
                            requirementId: requirement.id,
                            requirementType: requirement.requirement_template_type,
                            categoryId: requirement.requirement_category,
                            fileType: fileExtension,
                            fileSize: file.size
                          }
                        });
                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 8]]);
                }));
                return function (_x5, _x6) {
                  return _ref8.apply(this, arguments);
                };
              }()));
            case 24:
              trackVerificationEvents({
                trackEvent: trackEvent,
                responses: returnValue,
                userRole: userRole,
                requirement: requirement
              });
              verificationModalAttachmentIds = returnValue.filter(function (value) {
                var _value$data$data$attr;
                return (_value$data$data$attr = value.data.data.attributes.automated_verification_results) === null || _value$data$data$attr === void 0 ? void 0 : _value$data$data$attr.some(function (result) {
                  return result.result_code === VerificationResult.LOW_QUALITY || result.result_code === VerificationResult.NAME_NOT_MATCH;
                });
              }).map(function (value) {
                return value.data.data.id.toString();
              });
              setVerificationModalAttachmentIds(verificationModalAttachmentIds);
              hideProgress();
              if (onUploadFinished && typeof onUploadFinished === 'function') {
                onUploadFinished(returnValue);
              }
              return _context3.abrupt("return", returnValue);
            case 30:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }();
  }
}), withHandlers({
  onFiles: function onFiles(_ref9) {
    var onDrop = _ref9.onDrop;
    return function (event) {
      return onDrop(event.target.files);
    };
  }
}), dropzoneEnhancer, setPropTypes({
  requirement: PropTypes.object
}));

/**
 * @param {File} file
 * @returns {string}
 */
function getFileExtensionFromFile(file) {
  return getFileExtensionFromFilename(file.name);
}

/**
 * Tracks events related to any document verification results.  For example, the
 * backend will tell us if the image is too blurry.  In that case we track and
 * event to our analytics system so we can see how many images are returned as
 * blurry
 *
 * @param {object} params
 * @param {Array<{ data: { data: { attributes: { file_name: string, automated_verification_results: Array<{ result_code: string }> } } } }>} params.responses
 * @param {string} params.userRole
 * @param {{ id: number, requirement_template_id: number, requirement_category: string, requirement_template_type: string }} params.requirement
 * @param {(event: unknown) => void} params.trackEvent
 */
var trackVerificationEvents = function trackVerificationEvents(_ref10) {
  var _mapEventNameToErrorC;
  var requirement = _ref10.requirement,
    responses = _ref10.responses,
    userRole = _ref10.userRole,
    trackEvent = _ref10.trackEvent;
  var mapEventNameToErrorCode = (_mapEventNameToErrorC = {}, _defineProperty(_mapEventNameToErrorC, VerificationResult.CHECK_FAILURE, 'Document Verification Error'), _defineProperty(_mapEventNameToErrorC, VerificationResult.NOT_CHECKED, 'Document Verification Not Checked'), _defineProperty(_mapEventNameToErrorC, VerificationResult.LOW_QUALITY, 'Documents Flagged'), _defineProperty(_mapEventNameToErrorC, VerificationResult.NAME_NOT_MATCH, 'Documents Flagged'), _defineProperty(_mapEventNameToErrorC, VerificationResult.SUCCESSFULLY_PASSED, 'Document Verification Passed'), _mapEventNameToErrorC);
  responses.forEach(function (response) {
    if (hasVerificationResults(response)) {
      var firstResult = response.data.data.attributes.automated_verification_results[0];
      var eventName = mapEventNameToErrorCode[firstResult.result_code];
      var filename = response.data.data.attributes.file_name;
      var fileType = getFileExtensionFromFilename(filename);
      if (!eventName) {
        return;
      }
      trackEvent({
        event: "Single Application - Applicant Requirements - ".concat(eventName),
        data: {
          userRole: userRole,
          requirementId: requirement.id,
          requirementTemplateId: requirement.requirement_template_id,
          requirementType: requirement.requirement_template_type,
          categoryId: requirement.requirement_category,
          filename: filename,
          fileType: fileType,
          warningReasons: eventName === 'Documents Flagged' ? response.data.data.attributes.automated_verification_results.map(function (result) {
            var _result$output, _result$output$attrib, _result$output2, _result$output2$attri, _result$output3, _result$output3$attri;
            return {
              resultCode: result.result_code,
              firstNameFound: (_result$output = result.output) === null || _result$output === void 0 ? void 0 : (_result$output$attrib = _result$output.attributes) === null || _result$output$attrib === void 0 ? void 0 : _result$output$attrib.first_name_found,
              lastNameFound: (_result$output2 = result.output) === null || _result$output2 === void 0 ? void 0 : (_result$output2$attri = _result$output2.attributes) === null || _result$output2$attri === void 0 ? void 0 : _result$output2$attri.last_name_found,
              nameFound: (_result$output3 = result.output) === null || _result$output3 === void 0 ? void 0 : (_result$output3$attri = _result$output3.attributes) === null || _result$output3$attri === void 0 ? void 0 : _result$output3$attri.name_found
            };
          }) : undefined
        }
      });
    }
  });
};

/**
 * Checks if requirement attachment has results related to
 * @param {{ data: { data: { attributes: { automated_verification_results: Array<{ result_code: string }> } } } }} value
 */
var hasVerificationResults = function hasVerificationResults(value) {
  var results = value.data.data.attributes.automated_verification_results || [];
  return results.length > 0;
};
export default fileUploadsEnhancer;